window.cpap.onDocumentReady(() => {
  // Prevent multiple initializations
  if (window.cpap._plpBuyButtonsInitialized) return;
  window.cpap._plpBuyButtonsInitialized = true;

  // Using event delegation to reduce the number of event listeners
  // This improves memory usage and performance, especially with many buttons
  function handleSelectOptionButtonClick(event) {
    // Using closest() for more efficient element targeting
    const button = event.target.closest('.cpap__buy-buttons__select-option-button');
    if (!button) return;

    const rightRail = button.closest('.right-rail');
    if (!rightRail) return;

    event.preventDefault();
    event.stopPropagation();

    // 🚨 This is only for user-blocking logic. Nothing that is user-visible or background should be included here!
    // @see https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API#task_priorities
    window.scheduler.postTask(
      () => {
        const options = rightRail.querySelectorAll('.product-option');
        options.forEach((option) => {
          const select = option.querySelector('select');
          const errorTips = option.querySelector('.error-tips');

          if (select.value === '') {
            errorTips.classList.add('is-show');
            // Move logging to a background task since it's not critical for user experience
            window.scheduler.postTask(() => window.cpap.logFormError(errorTips), {
              priority: 'background',
            });
          } else {
            errorTips.classList.remove('is-show');
          }
        });
      },
      { priority: 'user-blocking' }
    );
  }

  document.addEventListener('click', handleSelectOptionButtonClick);
});
